<template>
<div class="question-content" style="width:670px;margin:0 auto">
  <div class="dialog-head">
    <p class="dialog-head-title">{{typeFormData.title}}</p>
    <p class="dialog-head-tips">{{typeFormData.startRemark}}</p>
  </div>
  <span class="tag">测评内容</span>
  <!-- <el-scrollbar style="height: 45vh"> -->
    <div v-for="(item, index) in typeFormData.questionAndItemList" :key="item.id" style="margin-left:10px">
      <p class="qs-title">
        <span v-if="item.sort">{{ item.sort }}、</span><span :class="[item.sort ?'':'main-title']">{{item.description}}</span>
        <img v-if="item.questionPropertyVO && item.questionPropertyVO.urlList && item.questionPropertyVO.urlList[0]" :src="`${ossBaseUrl}${item.questionPropertyVO.urlList[0]}`">
      </p>
      <el-row style="width: 100%;">
        <el-col>
          <!-- 单项选择 -->
          <div v-if="item.displayType === 1">
            <el-radio-group v-model="item.createTime">
              <el-radio v-for="(item1, index1) in item.questionItemList" :key="index1" :label="item1.label">
                <span>
                  {{item1.label}}<img v-if="item1.pictureUrl" :src="`${ossBaseUrl}${item1.pictureUrl}`">
                  <el-input v-if="item1.needInput" v-model="item1.column" size="medium" style="width:200px;margin-bottom:0" placeholder="请输入说明"></el-input>
                </span>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 多项选择 -->
          <div v-if="item.displayType === 2">
            <el-checkbox-group v-model="item.selectCheckList">
              <el-checkbox v-for="(item1, index1) in item.questionItemList" :key="index1" :label="item1.label">
                <span>
                  {{item1.label}}<img v-if="item1.pictureUrl" :src="`${ossBaseUrl}${item1.pictureUrl}`">
                  <el-input v-if="item1.needInput" v-model="item1.column" size="medium" style="width:200px;margin-bottom:0" placeholder="请输入说明"></el-input>
                </span>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <!-- 单项填空 -->
          <div v-if="item.displayType === 7">
            <el-input v-model="item.column" size="medium"></el-input>
          </div>
          <!-- 多项填空 -->
          <div v-if="item.displayType === 8">
            <div v-for="(item1, index1) in item.questionItemList" :key="index1" :label="item1.label">
              <p>{{item1.label}}<img v-if="item1.pictureUrl" :src="`${ossBaseUrl}${item1.pictureUrl}`"></p>
              <el-input v-model="item1.column" size="medium"></el-input>
            </div>
          </div>
          <!-- 文字填空 -->
          <div v-if="item.displayType === 9">
            <!-- <p>{{ index + 1 }}.{{item.description}}</p> -->
            <span v-for="(item1, index1) in item.questionItemList" :key="index1" :label="item1.label">
              <span style="display:inline-block;margin-right:10px">{{item1.label}}<img v-if="item1.pictureUrl" :src="`${ossBaseUrl}${item1.pictureUrl}`"></span>
              <el-input v-model="item1.column" style="width:100px;margin-right:10px" size="medium"></el-input>
            </span>
          </div>
          <!-- 打分题 -->
          <div v-if="item.displayType === 12">
            <span style="margin-left:7px">{{item.questionItemList[0].value}}</span>
            <el-radio-group v-model="item.createTime">
              <el-radio v-for="(item1, index1) in item.questionItemList" v-if="item1.label !== '-'" :key="index1" :label="item1.label">
                {{item1.label}}<span v-if="item1.value" style="margin-left:7px">{{item1.value}}</span>
              </el-radio>
            </el-radio-group>
            <span style="margin-left:7px">{{item.questionItemList[10].value}}</span>
          </div>
          <!-- 下拉题 -->
          <div v-if="item.displayType === 3">
            <el-select v-model="item.column" placeholder="请选择" size="medium">
              <el-option
                v-for="item1 in item.questionItemList"
                :key="item1.id"
                :label="item1.label"
                :value="item1.id">
              </el-option>
            </el-select>
          </div>
          <!-- 平级联选题 -->
          <div v-if="item.displayType === 4">
            <el-row :gutter="20">
              <!-- <el-col :span="6" v-for="(item2,index1) in item.placeholderList" :key="index1">
                <el-select v-if="item2.options.length" size="medium" v-model="item2.value"
                  :placeholder="item2.options[0].name"
                  style="width:100%;margin-bottom:20px"
                  @focus="(val) => {focusLevel(val, item)}"
                  @change="(val) => {changeSelect(val, item,item2, index1)}">
                  <el-option
                    v-for="item1 in item2.options"
                    :key="item1.id"
                    :label="item1.name"
                    :value="item1.id">
                  </el-option>
                </el-select>
              </el-col> -->
              <el-col :span="6" v-for="item in 4" :key="item">
                <el-select disabled
                  v-model="selectValue"
                  style="width:100%;margin-bottom:20px">
                  <el-option
                    v-for="item1 in cascaderOptions"
                    :key="item1.id"
                    :label="item1.name"
                    :value="item1.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </div>
          <!-- 图片上传题 -->
          <div v-if="item.displayType === 14">
            <el-row>
              <el-col>
                <div class="upload-wrap">
                  <i class="el-icon-plus" style="font-size:44px;color:#D8D8D8"></i>
                  <p style="font-size:12px;color: #999999;margin-top:17px">添加图片（禁止点击）</p>
                </div>
                <p style="font-size:12px;color: #999999;">*上传图片支持PNG/JPG格式，大小支持10M，最多可上传10张图片</p>
              </el-col>
            </el-row>
          </div>
          <!-- 下拉题—数字 -->
          <div v-if="item.displayType === 16">
            <el-select v-model="item.column" placeholder="请选择" size="medium">
              <el-option
                v-for="item1 in item.questionItemList"
                :key="item1.id"
                :label="item1.label"
                :value="item1.id">
              </el-option>
            </el-select>
          </div>
          <!-- 时间选择题 -->
          <div v-if="item.displayType === 17">
            <el-date-picker
              v-if="item.questionPropertyVO.type === 1"
              v-model="value1"
              type="year"
              disabled
              placeholder="选择日期时间">
            </el-date-picker>
            <el-date-picker
              v-if="item.questionPropertyVO.type === 2"
              v-model="value1"
              type="daterange"
              disabled
              range-separator="至"
              placeholder="选择日期时间">
            </el-date-picker>
          </div>
          <!-- 下拉题—数字-单位 -->
          <div v-if="item.displayType === 19">
            <el-row v-for="(v,k) in item.questionItemList" :key="k">
              <el-select v-model="v.questionItemPropertyVO.exclusive" placeholder="请选择" size="medium">
                <el-option
                  v-for="item1 in v.questionItemPropertyVO.numList"
                  :key="item1"
                  :label="item1"
                  :value="item1">
                </el-option>
              </el-select>
              <el-select v-model="v.questionItemPropertyVO.selectedUnit" placeholder="请选择" size="medium" style="margin-left:20px">
                <el-option
                  v-for="vv in v.questionItemPropertyVO.unitList"
                  :key="vv.name"
                  :label="vv.name"
                  :value="vv.name">
                </el-option>
              </el-select>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  <!-- </el-scrollbar> -->
</div>
</template>
<script>
import { queryLevelList } from "@/api/addQuestionnaire"
export default({
  props: {
    showQuestion: {
      type: Boolean
    },
    typeFormDatas: {
      type: Object
    }
  },
  data() {
    return {
      cascaderOptions: [],
      selectValue: '',
      value1: '',
      ossBaseUrl: process.env.VUE_APP_OSS_URL, //预览图片基础路径
      placeholderList: [],
      value: '',
      scoreSetDatas: {
        examPaperScoreVOList: [
          {
            startScore: '',
            endScore: '',
            analysis: '',
            examPaperId: this.$route.query.id
          }
        ],
        showScore: ''
      },
      options: [],
      typeFormData: {}
    }
  },
  watch: {
    typeFormDatas:{
      handler(val, oldVal){
        this.typeFormData = JSON.parse(JSON.stringify(val))
        this.typeFormData.questionAndItemList.map((item) => {
          if (item.displayType === 2) {
            // item.selectCheckList = []
            this.$set(item, 'selectCheckList', [])
          }
          if (item.displayType === 19) {
            item.questionItemList.forEach(v => {
              v.questionItemPropertyVO.numList = []
              if (v.questionItemPropertyVO.minNum && v.questionItemPropertyVO.maxNum && v.questionItemPropertyVO.interval) {
                for(let i = Number(v.questionItemPropertyVO.minNum);
                  i<= Number(v.questionItemPropertyVO.maxNum);
                  i=i+Number(v.questionItemPropertyVO.interval)) {
                  // this.$set(item.questionItemPropertyVO, 'numList', [])
                  v.questionItemPropertyVO.numList.push(i)
                }
              }
            })
          }
          if (item.displayType === 4) {
            item.placeholderList = [{
              options: [{
                name: item.firstName,
                id: item.firstNameId
              }],
              value: item.firstNameId
            },{
              options: [],
              value: ''
            },{
              options: [],
              value: ''
            },{
              options: [],
              value: ''
            },
            ]
          }
        })
      },
      deep:true
    }
  },
  created() {
    this.typeFormData = JSON.parse(JSON.stringify(this.typeFormDatas))
    this.typeFormData.questionAndItemList.map((item) => {
      if (item.displayType === 2) {
        this.$set(item, 'selectCheckList', [])
      }
      if (item.displayType === 19) {
        item.questionItemList.forEach(v => {
          v.questionItemPropertyVO.numList = []
          if (v.questionItemPropertyVO.minNum && v.questionItemPropertyVO.maxNum && v.questionItemPropertyVO.interval) {
            for(let i = Number(v.questionItemPropertyVO.minNum);
              i<= Number(v.questionItemPropertyVO.maxNum);
              i=i+Number(v.questionItemPropertyVO.interval)) {
              // this.$set(item.questionItemPropertyVO, 'numList', [])
              v.questionItemPropertyVO.numList.push(i)
            }
          }
        })
      }
      // if (item.displayType === 4) {
      //   item.placeholderList = [{
      //     options: [{
      //       name: item.firstName,
      //       id: item.firstNameId
      //     }],
      //     value: item.firstNameId
      //   },{
      //     options: [],
      //     value: ''
      //   },{
      //     options: [],
      //     value: ''
      //   },{
      //     options: [],
      //     value: ''
      //   },
      //   ]
      // }
    })
  },
  mounted() {},
  methods: {
    // 题型上的处理
    // 选择下拉项
    async changeSelect(val, item,item2, index1) {
      let res = await queryLevelList({
        level: index1 + 2,
        parentId: val,
        questionId: item.id,
        examPaperId: item.examPaperId
      })
      if (res.code === 0) {
        if (index1 !== 3) {
          this.$set(item.placeholderList[index1 + 1],'value','')
          this.$set(item.placeholderList[index1 + 1],'options',[])
        }
        if (index1 !== 3 && res.data.length) {
          this.$set(item.placeholderList[index1 + 1],'value',res.data[0].id)
          this.$set(item.placeholderList[index1 + 1],'options',res.data)
        }
        if (index1 === 0) {
          this.$set(item.placeholderList[2],'options',[])
          this.$set(item.placeholderList[2],'value','')
          this.$set(item.placeholderList[3],'options',[])
          this.$set(item.placeholderList[3],'value','')
        }
        if (index1 === 1) {
          this.$set(item.placeholderList[3],'options',[])
          this.$set(item.placeholderList[3],'value','')
        }
        this.$forceUpdate()
      }
    },
    // 聚焦下拉框
    async focusLevel(val, item) {
      let res = await queryLevelList({
        level: 1,
        parentId: 0,
        questionId: item.id,
        examPaperId: item.examPaperId
      })
      if (res.code === 0) {
        this.$set(item.placeholderList[0],'options',res.data)
        this.$forceUpdate()
      }
    }
  }
})
</script>

<style lang="less" scoped>
.main-title {
  font-size: 16px;
  font-weight: 700;
}
img {
  width: 80px;
  vertical-align: middle;
}
.el-radio,.el-checkbox {
  margin-bottom: 20px;
}
.el-select {
  margin-bottom: 20px;
}
div .el-input, span .el-input {
  margin-bottom: 20px;
}
p {
  margin-bottom: 15px;
}
.qs-title {
  // margin-bottom:20px;
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  // margin-top: 20px;
}
.dialog-head-title {
  // width: 260px;
  // height: 22px;
  font-size: 26px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  margin-bottom: 8px;
  text-align: center;
}
.dialog-head-tips {
  // width: 168px;
  // height: 17px;
  font-size: 12px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 17px;
  text-align: center;
}
// /deep/ .el-dialog__body {
//   max-height: 60vh;
//   overflow: auto;
//   padding: 30px;
//   padding-top: 0px;
// }
// /deep/ .el-dialog__title {
//   font-size: 26px;
//   font-weight: 500;
//   color: rgba(0, 0, 0, 0.85);
//   line-height: 22px;
//   padding: 30px;
// }
// /deep/ .el-dialog__footer {
//   padding: 30px;
// }
.tag {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 15px;
  display: flex;
}
.tag::before {
  content: '';
  display: block;
  width: 4px;
  height: 15px;
  background: #1A7BFC;
  margin-right: 15px;
  margin-top: 2.5px;
}
.add-item {
  width: calc(100% - 45px);
  background-color: #FCFCFC;
  border: 1px dashed #D9D9D9;
  color: #333333;
}
.score-set {
  display: flex;
}
.question-title {
  // width: 244px;
  // height: 22px;
  font-size: 14px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
}
.option-icon {
  width: 30px;
  height: 30px;
  background: #F2F7FE;
  border-radius: 50%;
  display: inline-block;
  color: #1A7BFC;
  text-align: center;
  line-height: 30px;
  margin-left: 15px;
  cursor: pointer;
  margin-top: 5px;
}
// /deep/.el-dialog__footer {
//   text-align: left;
// }
.question-content {
  background-color: #F2F7FE;
  padding: 20px 50px;
  // height: 68vh;
  // height: 64vh;
  height: 73vh;
  overflow: auto;
}
.upload-wrap {
  width: 142px;
  height: 142px;
  background: #F0F0F0;
  border-radius: 3px;
  border: 1px dashed #D9D9D9;
  padding: 36px 10px 26px 10px;
  text-align: center;
  margin-bottom: 10px;
}
</style>
<style lang="less">
.question-content {
  .el-date-editor .el-range-separator {
    width: 30px;
  }
}
</style>
